import { Box, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import brandLockup from '../../../asset/logo/lockup-horizontal-color.svg';
import { BORDER, CONTENT_MAX_WIDTH, PAGE_GUTTER, primaryButtonSx } from '../publicStyles';

interface PublicHeaderProps {
    /** Account pages show only the brand, so nothing competes with the form. */
    minimal?: boolean;
}

// Public pages carry only the brand and account entry points; product navigation
// belongs to the signed-in student and teacher shells.
export default function PublicHeader({ minimal = false }: PublicHeaderProps) {
    return (
        <Box component="header" sx={{
            position: 'sticky', top: 0, zIndex: 5,
            backgroundColor: 'rgba(255,255,255,0.96)', backdropFilter: 'blur(10px)',
            borderBottom: `1px solid ${BORDER}`,
        }}>
            <Stack direction="row" alignItems="center" sx={{ maxWidth: CONTENT_MAX_WIDTH, mx: 'auto', minHeight: 72, px: PAGE_GUTTER }}>
                <Box component={RouterLink} to="/mockup/public" aria-label="VerbaSchola home" sx={{ display: 'flex', borderRadius: '8px' }}>
                    <Box component="img" src={brandLockup} alt="VerbaSchola" sx={{ height: { xs: 22, sm: 26 }, width: 'auto', display: 'block' }} />
                </Box>
                {!minimal && <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
                    <Button component={RouterLink} to="/mockup/public/login" variant="text" sx={{ px: 2 }}>Log in</Button>
                    <Button component={RouterLink} to="/mockup/public/pilot" sx={{ ...primaryButtonSx, minHeight: 44, display: { xs: 'none', sm: 'inline-flex' } }}>Request a pilot</Button>
                </Stack>}
            </Stack>
        </Box>
    );
}
